/* eslint-disable no-underscore-dangle */
import { fabric } from 'fabric';

const loadSlide = (fabricRef, slideContent) => {
  const slideContentWithoutTexts = {
    ...JSON.parse(slideContent),
    objects: JSON.parse(slideContent).objects?.filter(
      (object) => object.type !== 'i-text',
    ),
  };
  fabricRef.current.loadFromJSON(slideContentWithoutTexts, () => {
    JSON.parse(slideContent)
      .objects?.filter((object) => object.type === 'i-text')
      .map((object) => {
        const text = new fabric.Textbox(object.text, object);
        object.styles.map((style) => {
          text.selectionStart = style.start;
          text.selectionEnd = style.end;
          text.setSelectionStyles(style.style);
          return null;
        });
        fabricRef.current.add(text);
        return null;
      });
    fabricRef.current.renderAll.bind(fabricRef.current);
  });
};

export default loadSlide;
